import { FormPageModel } from '../kiosk';
import { OptionDataPayload, OptionFileInput } from '../options';
import { GenericOptionInput, ProductModel } from '../orders/product';
import { RaffleWithUserDetails } from '../orders/raffle';
import { BadgeDesign } from '../user/badgeDesign';
import { RegistrationTicket, UserReferenceModel } from '../user/base';

export const internalRegistrationFlags = new Set(['nukeme']);

export interface RegistrationUserInfo {
  id?: number;
  profilePictureUrl?: string;
}

export interface RegistrationFlagModel {
  description: string;
  enabledDescription: string | null;
  id: number;
  shortName: string;
  sortOrder: number;
  visibility: boolean;
}

export interface RegistrationFlagUser extends UserReferenceModel {
  badgeName: string;
}

export interface RegistrationOptionInput extends GenericOptionInput {
  fromRegistration: boolean;
  fromProduct: boolean;
  productOptionId?: number;
}

export interface ConRegistrationForm {
  terms: string;
  badgeDesign?: BadgeDesign;
  flags: RegistrationFlagModel[];
  options: RegistrationOptionInput[];
  products: ProductModel[];
  formLayout: FormPageModel;
}

export interface RegistrationUpsert {
  attendanceTypeId: number;
  badgeName: string;
  emergencyContactName1?: string | null;
  emergencyContactName2?: string | null;
  emergencyContactPhone1?: string | null;
  emergencyContactPhone2?: string | null;
  flags: number[];
  options: OptionDataPayload;
  badgeArtId: number | null;
  profilePicture?: OptionFileInput | null;
  raffle?: RegistrationTicket;
  force?: boolean;
}

export interface RegistrationInfo {
  badgeArtId: number | null;
  badgeId: number;
  badgeName: string;
  badgePrinted: number | null;
  emergencyContactName1: string | null;
  emergencyContactName2: string | null;
  emergencyContactPhone1: string | null;
  emergencyContactPhone2: string | null;
  flags: number[];
  id: number;
  user: UserReferenceModel;
  paidOrderItem?: {
    id: number;
    productId: number;
  };
  attendanceType: {
    id: number;
    name: string;
    displayName: string | null;
    raffleId: number | null;
  };
  options: OptionDataPayload;
  raffle?: RaffleWithUserDetails;
}
